import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import back from '../assets/icon/back.svg';
import './WritingTest.css';

const WritingTest = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const surahParam = searchParams.get('surah');
  const modeParam = searchParams.get('mode') || 'full';
  const startParam = parseInt(searchParams.get('start'), 10);
  const endParam = parseInt(searchParams.get('end'), 10);

  const [pagesData, setPagesData] = useState({});
  const [pageNumbers, setPageNumbers] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [typedText, setTypedText] = useState('');
  const [result, setResult] = useState(null);
  const [surahName, setSurahName] = useState('');

  useEffect(() => {
    if (!surahParam) return;
    fetch(`https://api.alquran.cloud/v1/surah/${surahParam}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.code === 200) {
          let list = data.data.ayahs.map((a) => ({
            number: a.numberInSurah,
            text: a.text,
            page: a.page,
          }));

          if (modeParam === 'range') {
            if (
              !isNaN(startParam) &&
              !isNaN(endParam) &&
              startParam >= 1 &&
              endParam <= list.length &&
              startParam <= endParam
            ) {
              list = list.slice(startParam - 1, endParam);
            }
          }

          setSurahName(data.data.name);
          const grouped = {};
          list.forEach((a) => {
            if (!grouped[a.page]) grouped[a.page] = [];
            grouped[a.page].push(a);
          });
          const numbers = Object.keys(grouped)
            .map((n) => parseInt(n, 10))
            .sort((a, b) => a - b);
          setPagesData(grouped);
          setPageNumbers(numbers);
          setCurrentPage(0);
          setTypedText('');
          setResult(null);
        }
      })
      .catch((err) => console.error(err));
  }, [surahParam, modeParam, startParam, endParam]);

  const handlePrev = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
      setTypedText('');
      setResult(null);
    }
  };

  const handleNext = () => {
    if (currentPage < pageNumbers.length - 1) {
      setCurrentPage(currentPage + 1);
      setTypedText('');
      setResult(null);
    }
  };

  const handleSubmit = async () => {
    const pageAyahs = pagesData[pageNumbers[currentPage]] || [];
    if (pageAyahs.length === 0) return;
    const quranText = pageAyahs.map((a) => a.text).join(' ');

    const body = {
      typed_text: typedText,
      quran_text: quranText,

    };
    try {
      const config = { headers: { 'Content-Type': 'application/json' } };
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}compare-ayahs/`,
        body,
        config
      );
      setResult(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  if (!surahParam || pageNumbers.length === 0) return null;

  return (
    <div className="writing-test">
      <div className="test-header">
        <div className="back-icon-container">
          <img
            className="back-icon"
            src={back}
            alt="back"
            onClick={() => navigate(-1)}
          />
        </div>
        <h1 className="test-title">اختبار الكتابة</h1>
      </div>
      {surahName && <h2 className="surah-name">{surahName}</h2>}
      <textarea
        className="writing-input"
        value={typedText}
        onChange={(e) => setTypedText(e.target.value)}
        rows={6}
      />
      <button className="check-button" onClick={handleSubmit}>
        تحقق
      </button>
      {result && <div className="result-text">{JSON.stringify(result)}</div>}
      {pageNumbers.length > 1 && (
        <div className="page-nav-container">
          <button
            className="page-nav-button"
            onClick={handlePrev}
            disabled={currentPage === 0}
          >
            الصفحة السابقة
          </button>
          <button
            className="page-nav-button"
            onClick={handleNext}
            disabled={currentPage === pageNumbers.length - 1}
          >
            الصفحة التالية
          </button>
        </div>
      )}
    </div>
  );
};

export default WritingTest;